import styled, { css } from 'styled-components';
import { FormLabel, FormHelperText, withStyles } from '@material-ui/core';
import { TextField } from '@avangard/ui/core';
import { black, red } from '@avangard/ui/colors';

export const StyledFormLabel = withStyles(() => ({
    root: {
        width: '100%',
        marginBottom: 10,
        color: black[80],
        fontSize: '1.4rem',
        fontWeight: 400,
    },
    asterisk: {
        color: red[100],
    },
}))(FormLabel);

export const StyledFormHelperText = withStyles(() => ({
    root: {
        width: '100%',
    },
}))(FormHelperText);

export const TextFieldWithHiddenLabel = withStyles(() => ({
    root: {
        '& .MuiInputLabel-root': {
            opacity: 0,
            visibility: 'hidden',
        },
    },
}))(TextField);

export const FormRow = styled.div<{ grid?: boolean }>`
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;
    width: 100%;

    ${p =>
        p.grid &&
        css`
            display: grid;
            grid-template-columns: repeat(2, 1fr);
            gap: 24px;
        `}
`;

export const Clarification = styled.div`
    width: 100%;
    margin-top: 8px;
`;

export const ClarificationTextField = withStyles(() => ({
    root: { minWidth: 400 },
}))(TextField);
